import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./AddDocument.module.scss";
import { CloseIcon } from "Assets/icons";
import { Formik } from "formik";
import { useGetAppointmentGuardianSubmittedFormQuery, useGetAppointmentTherapistFormQuery } from "store/services/appointment";
// import addAppointmentSchema from "./addAppointment.schema";
import { RequiredFieldAstrick } from "components/Common/Common";
import AppInputField from "components/shared/FormComponents/AppInputField";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { AppRadioField } from "components/shared/FormComponents/AppRadioField";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useEffect, useState } from "react";


const AppointmentTherapistFormPop = ({ show, setShow, currentAppointment, currentEntry, setAnswers, setShowBookingPop }) => {

    const [initialValues, setInitialValues] = useState({})

    const { data: therapistForm, isFetching: therapistFormLoading } = useGetAppointmentGuardianSubmittedFormQuery({ id: currentEntry?.id }, { skip: !currentEntry?.id })

    console.log('currentEntry', currentEntry)
    const generateInitialValues = (questionsList) => {
        const values = {};
        questionsList?.forEach((q) => {
            const key = `question_${q.id}`;
            switch (q.question_type) {
                case 'checkbox':
                    values[key] = q.associatedQuesAnswers[0]?.answer?.length > 0 ? q.associatedQuesAnswers[0]?.answer : [];
                    break;
                case 'date':
                    values[key] = q.associatedQuesAnswers[0]?.answer;
                    break;
                default:
                    values[key] = q.associatedQuesAnswers[0]?.answer || "";
            }
        });
        return values;
    };

    const handlePopup = () => setShow(!show);

    const handleSubmit = async (values, event) => {
        const answerPayload = therapistForm?.questionsList?.map((question) => {
            const fieldName = `question_${question.id}`;
            return {
                question_id: question.id,
                answer_type: question.question_type,
                answer: values[fieldName] || (question.question_type === 'checkbox' ? [] : "")
            };
        });
        setAnswers(answerPayload)
        setShowBookingPop(true)
        handlePopup()
    };



    useEffect(() => {
        if (therapistForm) {
            const values = generateInitialValues(therapistForm?.questionsList || [])
            console.log("SET INIT ", values)
            setInitialValues(values)
        }
    }, [therapistForm])



    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="xl"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <Button
                        onClick={handlePopup}
                        className="border-0 p-0 position-absolute"
                        variant="transparent"
                        style={{ right: 15, top: 10 }}
                    >
                        <CloseIcon />
                    </Button>
                    <div>
                        <h6 className="m-0 fw-bold themeBlue"> 
                           Pre-Booking Appointment Form
                        </h6>
                    </div>
                    {therapistFormLoading ? <LoadingIndicator /> : <div>
                        <Formik
                            enableReinitialize
                            initialValues={initialValues}
                            // validationSchema={addAppointmentSchema}
                            onSubmit={handleSubmit}
                        >
                            {
                                ({
                                    handleSubmit,
                                    setFieldValue,
                                    values,
                                    resetForm
                                }) => (
                                    <Form onSubmit={handleSubmit}>
                                        <div className='mt-3' >
                                            {/* <div class="justify-self-center">
                                                {therapistForm?.questionsList ? "No Form available for this therapist" : null}
                                            </div> */}
                                            <div className=''>
                                                {/* <div className='mt-2'>
                                                    <label htmlFor="">Reason <RequiredFieldAstrick /></label>
                                                    <AppInputField
                                                        placeholder="Enter Reason"
                                                        name="appointment_reason"
                                                        className="form-control"
                                                        maxLength={500}
                                                        fieldType={"textarea"}
                                                        style={{ height: "80px" }}
                                                    />
                                                </div> */}

                                                {
                                                    therapistForm?.questionsList?.map((item, index) => (
                                                        ["input", "textarea"]?.includes(item?.question_type) ?
                                                            <>
                                                                <div className='mt-2'>

                                                                    <label htmlFor="">{`Q${index + 1}:`} {item?.question} {item?.is_required === "yes" && <RequiredFieldAstrick />}</label>
                                                                    <AppInputField
                                                                        disabled
                                                                        placeholder={item?.placeholder || ""}
                                                                        name={`question_${item?.id}`}
                                                                        className="form-control"
                                                                        maxLength={500}
                                                                        fieldType={"textarea"}
                                                                        style={{ height: "80px" }}
                                                                    />
                                                                </div>
                                                            </> :
                                                            item?.question_type == 'radio' ?
                                                                <div className='mt-2'>
                                                                    <label htmlFor="">{`Q${index + 1}:`} {item?.question} {item?.is_required === "yes" && <RequiredFieldAstrick />}</label>
                                                                    <AppRadioField
                                                                        name={`question_${item?.id}`}
                                                                        className="radio-accent-color"
                                                                        // style={{ height: "80px" }}
                                                                        options={item?.options}
                                                                        isReadOnly={true}
                                                                    />
                                                                </div>
                                                                :
                                                                item?.question_type == 'date' ?
                                                                    <div className='mt-2'>
                                                                        <label htmlFor="">{`Q${index + 1}:`} {item?.question} {item?.is_required === "yes" && <RequiredFieldAstrick />}</label>
                                                                        <AppDatePicker
                                                                            disabled
                                                                            className="form-control"
                                                                            name={`question_${item?.id}`}
                                                                        // style={{ height: "80px" }}
                                                                        />
                                                                    </div>
                                                                    :
                                                                    item?.question_type == "checkbox" &&
                                                                    <div className='mt-2'>

                                                                        <label htmlFor="">{`Q${index + 1}:`} {item?.question} {item?.is_required === "yes" && <RequiredFieldAstrick />}</label>

                                                                        {item?.options?.map(({ label, value }) => (
                                                                            <label key={value} className="mt-2 d-flex gap-2">
                                                                                <input
                                                                                    name={`question_${item?.id}`}
                                                                                    type="checkbox"
                                                                                    value={value}
                                                                                    checked={values?.[`question_${item?.id}`]?.includes(value)}
                                                                                />
                                                                                {label}
                                                                            </label>
                                                                        ))}
                                                                    </div>
                                                    ))

                                                }
                                            </div>

                                            {/* <Row className="mt-3">
                                                {console.log('initialValues', initialValues)}
                                                <Col md="12">
                                                    <button
                                                        className='commonBtn py-3 h-auto btn btn-primary w-100'
                                                        type='submit'
                                                        disabled={false}
                                                    >
                                                        {false ? <LoadingIndicator inline color='#fff' /> : "Submit"}
                                                    </button>
                                                </Col>
                                            </Row> */}

                                        </div>
                                    </Form>
                                )}
                        </Formik>
                    </div>}

                </Modal.Body>
            </Modal >
        </>
    );
};

export default AppointmentTherapistFormPop;